export const environment = {
    API_URL: "https://dev-api-gate.estatex.tech",
    SITEKEY: "6LcSzQ8qAAAAANNums3Ot7Us1MDlPYcEd-jXmeBo",
    // Need to Fix implementation and get it dynamically
    PROPERTY_ID: 1,
    ENVIRONMENT: "development",
};
